// Local-dev only: preview a specific store on the shared localhost storefront.
//
// In production the storefront resolves its tenant by Host ({handle}.platform.com),
// so every store has its own origin. In local dev there is a single shared origin
// (localhost:3100) whose Vite proxy stamps a fixed X-Store-Handle (STORE_HANDLE,
// default "demo") — so every dashboard "Preview"/"View live" used to open the same
// store. The dashboard now opens the storefront with `?preview_store={handle}`; we
// capture it here (once per tab), and forward it as X-Store-Handle on every /api
// call so the dev proxy resolves THAT store instead of its default.
//
// Guarded by import.meta.env.DEV → in a production build the whole thing is dead
// code (statically eliminated), so this can never override tenant resolution live.

const KEY = "dk:dev:preview_store"

/** Capture ?preview_store from the URL into per-tab storage. Call once at startup
 *  (before the first API call). No-op in production. */
export function initDevStore(): void {
  if (!import.meta.env.DEV) return
  try {
    const h = new URLSearchParams(location.search).get("preview_store")
    if (h) sessionStorage.setItem(KEY, h)
  } catch {
    /* sessionStorage unavailable — ignore */
  }
}

/** The dev preview store handle to forward, or "" when none is active / in prod. */
export function devStoreHandle(): string {
  if (!import.meta.env.DEV) return ""
  try {
    return sessionStorage.getItem(KEY) ?? ""
  } catch {
    return ""
  }
}
